
import UICreatePost from '@/components/ui/organism/UICreatePost';
import CloseIcon from '~/components/ui/icons/CloseIcon.vue';
import CustomModal from '~/components/ui/molecule/CustomModal.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'UICreatePostMobileModal',
  components: { UICreatePost, CloseIcon, CustomModal },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    profileImg: {
      type: String,
      required: true,
    },
    profileName: {
      type: String,
      required: true,
    },
    clear: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    uploadImage: {
      type: Function,
      required: true,
    },
    searchMentions: {
      type: Function,
      required: true,
    },
    searchHashtags: {
      type: Function,
      required: true,
    },
    targetType: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'create_post',
    },
    mentionedPost: {
      type: Object,
      default: () => null,
    },
    originalPost: {
      type: Object,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    portfolio: {
      type: Object,
      default: () => null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    post: {
      type: Object,
      default: () => null,
    },
    transactionData: {
      type: Object,
      default: () => null,
      required: false,
    },
    isEmailConfirmed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      submitPost: false,
      editPost: false,
      isPoll: false,
      postButtonState: true,
      isPostEmpty: true,
    };
  },
  computed: {
    ...mapGetters('authentication', ['profile']),
    ...mapGetters('modals', ['showCreatePostModalRes']),
    league() {
      return this.showCreatePostModalRes.league;
    },
  },
  watch: {
    show() {
      if (this.show) {
        document.body.classList.add('overflow-hidden');
      } else {
        document.body.classList.remove('overflow-hidden');
      }
    },
  },
  methods: {
    propagateSubmitPost() {
      this.submitPost = true;
    },
    propagateEditPost() {
      this.editPost = true;
    },
    onCurrentMediaChange(value) {
      this.isPoll = value;
    },
    updatePostButtonState(state) {
      this.postButtonState = state;
    },
    resetPostButtonState() {
      this.postButtonState = true;
    },
    handlePostEmptyChange(val) {
      this.isPostEmpty = val;
    },
  },
};
